// QuotationPreview.js
import React from "react";
import { Document, Page, Text, View, Font } from "@react-pdf/renderer";
import Header from "../components/quotation-preview/Header";
import Content from "../components/quotation-preview/Content";
import Footer from "../components/quotation-preview/Footer";
import { styles } from "./styles";

// ✅ ลงทะเบียนฟอนต์
Font.register({
  family: "NotoSansThai",
  fonts: [
    { src: "/fonts/NotoSansThai-Regular.ttf" },
    { src: "/fonts/NotoSansThai-Bold.ttf", fontWeight: "bold" },
  ],
});

const QuotationPreview = ({ quotationData, bankInfo, isDetailedForm }) => {
  const MAX_ITEMS_PER_PAGE = isDetailedForm ? 4 : 10;

  const isSpecialForm = quotationData.isSpecialForm; // ✅ ประกาศตัวนี้

  let pages = [];

  if (isSpecialForm) {
    let currentPageItems = [];
    let currentLineCount = 0;
    let currentStartIndex = 0;

    quotationData.items.forEach((item, index) => {
      const lineCount = (item.description.match(/\n/g) || []).length + 1;

      if (currentLineCount + lineCount > 50) {
        pages.push({
          type: "content",
          items: currentPageItems,
          startIndex: currentStartIndex, // ✅ บอก index เริ่ม
        });
        currentPageItems = [];
        currentLineCount = 0;
        currentStartIndex = index; // ✅ index ตัวใหม่
      }

      currentPageItems.push(item);
      currentLineCount += lineCount;
    });

    if (currentPageItems.length > 0) {
      pages.push({
        type: "content",
        items: currentPageItems,
        startIndex: currentStartIndex,
      });
    }

    pages.push({
      type: "summary",
    });
  } else {
    // ✅ NORMAL FORM (standard/detailed)
    let currentPage = [];
    let currentLines = 0;
    let currentStartIndex = 0;

    quotationData.items.forEach((item, index) => {
      if (currentLines >= MAX_ITEMS_PER_PAGE) {
        pages.push({
          type: "content",
          items: currentPage,
          startIndex: currentStartIndex,
        });
        currentStartIndex += currentPage.length;
        currentPage = [];
        currentLines = 0;
      }
      currentPage.push(item);
      currentLines++;
    });

    if (currentPage.length > 0) {
      pages.push({
        type: "content",
        items: currentPage,
        startIndex: currentStartIndex,
      });
    }
  }

  return (
    <Document>
      {isSpecialForm ? (
        <>
          {pages.map((page, pageIndex) =>
            page.type === "content" ? (
              <Page key={pageIndex} size="A4" style={styles.page}>
                <Header quotationData={quotationData} />
                <Content
                  quotationData={{ ...quotationData, items: page.items }}
                  startIndex={page.startIndex}
                  isSpecialForm
                />
                <View style={styles.pageNumber}>
                  <Text>
                    {pageIndex + 1} / {pages.length}
                  </Text>
                </View>
              </Page>
            ) : (
              <Page key="summary" size="A4" style={styles.page}>
                <Header quotationData={quotationData} />
                <Footer quotationData={quotationData} bankInfo={bankInfo} />
                <View style={styles.pageNumber}>
                  <Text>
                    {pages.length} / {pages.length}
                  </Text>
                </View>
              </Page>
            )
          )}
        </>
      ) : (
        pages.map(({ items, startIndex }, pageIndex) => (
          <Page key={pageIndex} size="A4" style={styles.page}>
            <Header quotationData={quotationData} />
            <Content
              quotationData={{ ...quotationData, items }}
              startIndex={startIndex}
            />
            {pageIndex === pages.length - 1 && (
              <Footer quotationData={quotationData} bankInfo={bankInfo} />
            )}
            <View style={styles.pageNumber}>
              <Text>
                {pageIndex + 1} / {pages.length}
              </Text>
            </View>
          </Page>
        ))
      )}
    </Document>
  );
};

export default QuotationPreview;
